import { ChangePasswordPage } from '@zzk/admin-pages';
import { createElement } from 'react';
import { createFieldState } from '@zzk/ui';

export const settingsPasswordFields = {
  currentPassword: createFieldState({
    name: 'currentPassword',
    label: 'Current password',
    value: '',
    required: true,
  }),
  newPassword: createFieldState({
    name: 'newPassword',
    label: 'New password',
    value: '',
    required: true,
  }),
} as const;

export function createSettingsPasswordView() {
  return createElement(ChangePasswordPage, {
    'data-zzk-settings-password-form': true,
  } as Parameters<typeof ChangePasswordPage>[0]);
}
